export default "https://cdn-static-staging.gokick.com/assets/de9826e8866da471b448810e2f95d57cb57ac3c9/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";